import { useState } from 'react';
import { Table, Card, Form, Row, Col, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { exceptionsService } from '@/services/api';
import { useAsync } from '@/common/hooks/use-async';
import { AsyncBoundary } from '@/common/components/async-boundary';

const STATE_VARIANT: Record<string, string> = {
  DRAFTED: 'secondary', APPROVED: 'success', REJECTED: 'danger',
  SUBMITTED: 'info', WITHDRAWN: 'dark', RETIRED: 'light',
};

export default function ExceptionsList() {
  const [repo, setRepo] = useState('');
  const [state, setState] = useState('DRAFTED');
  const { data, loading, error } = useAsync(
    () => exceptionsService.listExceptions({ repo: repo || undefined, state: state || undefined }),
    [repo, state],
  );
  const items = data?.items ?? [];

  return (
    <Card>
      <Card.Header>Exceptions</Card.Header>
      <Card.Body>
        <Row className="g-2 mb-3">
          <Col md={6}>
            <Form.Control
              placeholder="repo (workspace/slug) — optional"
              value={repo}
              onChange={(e) => setRepo(e.target.value)}
            />
          </Col>
          <Col md={3}>
            <Form.Select value={state} onChange={(e) => setState(e.target.value)}>
              {['DRAFTED', 'APPROVED', 'REJECTED', 'SUBMITTED', 'WITHDRAWN', 'RETIRED'].map((s) => (
                <option key={s} value={s}>{s}</option>
              ))}
            </Form.Select>
          </Col>
        </Row>
        <AsyncBoundary loading={loading} error={error}>
          <Table hover responsive>
            <thead>
              <tr>
                <th>CVE</th>
                <th>Repo</th>
                <th>State</th>
                <th>PR state</th>
                <th>Component</th>
                <th>REQ#</th>
              </tr>
            </thead>
            <tbody>
              {items.map((e) => (
                <tr key={e.exceptionId}>
                  <td>
                    <Link to={`/exceptions/detail?exceptionId=${encodeURIComponent(e.exceptionId)}`}>
                      {e.cveId}
                    </Link>
                  </td>
                  <td>{e.repo}</td>
                  <td><Badge bg={STATE_VARIANT[e.state] ?? 'secondary'}>{e.state}</Badge></td>
                  <td>{e.prState ?? '-'}</td>
                  <td>{e.component ?? '-'}</td>
                  <td>{e.serviceNowReqNumber ?? '-'}</td>
                </tr>
              ))}
              {!items.length && (
                <tr><td colSpan={6} className="text-muted">No exceptions.</td></tr>
              )}
            </tbody>
          </Table>
        </AsyncBoundary>
      </Card.Body>
    </Card>
  );
}
